var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsupIconLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_797_1053)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.56699 24.7003C1.56581 28.9013 2.67206 33.0032 4.77558 36.6187L1.36581 48.9718L14.1064 45.6571C17.6303 47.5606 21.5786 48.558 25.5908 48.5582H25.6014C38.8465 48.5582 49.6283 37.8639 49.634 24.7191C49.6365 18.3495 47.1389 12.36 42.601 7.85378C38.0639 3.34796 32.0297 0.865212 25.6004 0.862305C12.3537 0.862305 1.57265 11.5561 1.56718 24.7003",
    fill: "url(#paint0_linear_797_1053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.708984 24.693C0.707617 29.0452 1.85352 33.2938 4.03203 37.0388L0.5 49.8347L13.6975 46.4012C17.3338 48.3684 21.4279 49.4056 25.5939 49.4072H25.6047C39.325 49.4072 50.4941 38.3281 50.5 24.7128C50.5023 18.1143 47.9148 11.9095 43.2148 7.24186C38.5143 2.57481 32.2643 0.00271318 25.6047 0C11.882 0 0.714453 11.0775 0.708984 24.693ZM8.56855 36.3938L8.07578 35.6176C6.0043 32.3494 4.91094 28.5727 4.9125 24.6946C4.9168 13.3777 14.1988 4.17054 25.6125 4.17054C31.1398 4.17287 36.3344 6.31085 40.2414 10.1899C44.1482 14.0694 46.298 19.2264 46.2967 24.7112C46.2916 36.0281 37.0094 45.2364 25.6047 45.2364H25.5965C21.883 45.2345 18.241 44.245 15.0648 42.375L14.309 41.9302L6.47734 43.9676L8.56855 36.3938Z",
    fill: "url(#paint1_linear_797_1053)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3824 14.3699C18.9164 13.3422 18.426 13.3214 17.9828 13.3034C17.6199 13.2879 17.2051 13.2891 16.7906 13.2891C16.3758 13.2891 15.7018 13.4439 15.132 14.0612C14.5617 14.679 12.9547 16.172 12.9547 19.2087C12.9547 22.2455 15.1838 25.1802 15.4945 25.5924C15.8057 26.0038 19.7978 32.4348 26.1205 34.9088C31.3752 36.9649 32.4445 36.5559 33.585 36.4528C34.7256 36.3501 37.2654 34.9602 37.7836 33.5189C38.3021 32.0778 38.3021 30.8426 38.1467 30.5844C37.9912 30.3273 37.5764 30.1728 36.9543 29.8643C36.332 29.5556 33.2738 28.0623 32.7037 27.8563C32.1334 27.6505 31.7187 27.5478 31.3039 28.1658C30.8891 28.7829 29.6978 30.1728 29.3348 30.5844C28.9721 30.997 28.609 31.0484 27.9871 30.7397C27.3646 30.43 25.3613 29.779 22.9846 27.6765C21.1353 26.0404 19.8869 24.0201 19.524 23.4021C19.1611 22.785 19.4852 22.4505 19.7971 22.143C20.0766 21.8664 20.4193 21.4222 20.7307 21.062C21.0408 20.7015 21.1443 20.4443 21.3518 20.0327C21.5594 19.6207 21.4555 19.2602 21.3002 18.9515C21.1443 18.6428 19.9355 15.5902 19.3824 14.3699Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_797_1053",
    x1: 2414.77,
    y1: 4811.81,
    x2: 2414.77,
    y2: 0.862305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_797_1053",
    x1: 2500.5,
    y1: 4983.47,
    x2: 2500.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_797_1053"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsupIconLogin);
export default __webpack_public_path__ + "static/media/WhatsupIconLogin.d6fc2d4e2264814fd7c6690f04d8a77c.svg";
export { ForwardRef as ReactComponent };